var React = require('react');

function Thunder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.10008 0.8L4.90008 6C4.70008 6.3 5.00008 6.7 5.40008 6.7H6.90008C7.30008 6.7 7.60008 7.1 7.40008 7.5L3.80008 14.7C3.50008 15.3 2.60008 15 2.70008 14.3L3.80008 9.3C3.80008 9 3.60008 8.7 3.20008 8.7H1.50008C1.20008 8.7 0.900084 8.3 1.00008 7.9L3.20008 0.4C3.30008 0.2 3.50008 0 3.80008 0H6.60008C7.00008 0 7.30008 0.4 7.10008 0.8Z"}));
}

Thunder.defaultProps = {"width":"8","height":"16","viewBox":"0 0 8 16"};

module.exports = Thunder;

Thunder.default = Thunder;
